import type {
  PutDocumentsUserRolesRequestType,
  PutDocumentsUserRolesResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const putDocumentUserRoles = async ({
  documentId,
  ...body
}: PutDocumentsUserRolesRequestType) => {
  const url = `/api/v2/documents/${documentId}/user-roles`;
  const response = await apiAuthClient.put<PutDocumentsUserRolesResponseType>(
    url,
    body,
  );

  return {
    ...response.data,
    data: response.data.data.map(item => ({
      ...item,
      direct: true,
    })),
  };
};
